/**
 * Default `extensions.code` set on a UserFacingError. Unlike the `userFacing`
 * marker — which graphqlErrorFormatter strips before the response leaves the
 * server in release — this code survives sanitization, so it is the reliable
 * key a client uses to recognize and surface a user-facing error message in
 * production. Shared between the API (which stamps it) and Oak (which reads it).
 */
export const USER_FACING_ERROR_CODE = "USER_FACING_ERROR";
